export default __webpack_public_path__ + "imgs/toKnow02.341a807.jpeg";